var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_c('b-card-actions', {
    attrs: {
      "title": "Filters",
      "action-collapse": ""
    }
  }, [_c('div', [_c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Enter Transaction Date Range",
      "config": {
        mode: 'range'
      }
    },
    on: {
      "input": _vm.filterByTransactionDate
    },
    model: {
      value: _vm.filterRangeDate,
      callback: function callback($$v) {
        _vm.filterRangeDate = $$v;
      },
      expression: "filterRangeDate"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "options": _vm.filterFromAccountOptionId,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "From Account"
    },
    on: {
      "input": _vm.filterByAccount
    },
    model: {
      value: _vm.filterFromAccountId,
      callback: function callback($$v) {
        _vm.filterFromAccountId = $$v;
      },
      expression: "filterFromAccountId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mr-sm-1 mb-1 mb-sm-0 custom-font",
    attrs: {
      "options": _vm.filterToAccountOptionId,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "To Account"
    },
    on: {
      "input": _vm.filterByAccount
    },
    model: {
      value: _vm.filterToAccountId,
      callback: function callback($$v) {
        _vm.filterToAccountId = $$v;
      },
      expression: "filterToAccountId"
    }
  })], 1)], 1)], 1)])], 1), _c('div', [_c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_vm.$permissionAbility(_vm.ACCOUNT_TRANSFER_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" Transfer Account ")])] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table table-custom-style striped",
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$row$fromAccoun, _props$row$fromAccoun2, _props$row2, _props$row2$fromAccou, _props$row2$fromAccou2, _props$row3, _props$row3$fromAccou, _props$row3$fromAccou2, _props$row4, _props$row4$fromAccou, _props$row4$fromAccou2, _props$row5, _props$row5$fromAccou, _props$row5$fromAccou2, _props$row6, _props$row6$fromAccou, _props$row6$fromAccou2, _props$row7, _props$row7$fromAccou, _props$row7$fromAccou2, _props$row8, _props$row8$fromAccou, _props$row8$fromAccou2, _props$column2, _props$row9, _props$row9$toAccount, _props$row9$toAccount2, _props$row10, _props$row10$toAccoun, _props$row10$toAccoun2, _props$row11, _props$row11$toAccoun, _props$row11$toAccoun2, _props$row12, _props$row12$toAccoun, _props$row12$toAccoun2, _props$row13, _props$row13$toAccoun, _props$row13$toAccoun2, _props$row14, _props$row14$toAccoun, _props$row14$toAccoun2, _props$row15, _props$row15$toAccoun, _props$row15$toAccoun2, _props$row16, _props$row16$toAccoun, _props$row16$toAccoun2, _props$column3, _props$column4, _props$row18, _props$row19, _props$column5, _props$row20, _props$row21, _props$column6, _props$row22, _props$row23;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_from_account' ? [_c('span', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : (_props$row$fromAccoun = _props$row.fromAccount) === null || _props$row$fromAccoun === void 0 ? void 0 : (_props$row$fromAccoun2 = _props$row$fromAccoun.data) === null || _props$row$fromAccoun2 === void 0 ? void 0 : _props$row$fromAccoun2.name))]), _c('div', {
          staticClass: "cell-with-description"
        }, [props !== null && props !== void 0 && (_props$row2 = props.row) !== null && _props$row2 !== void 0 && (_props$row2$fromAccou = _props$row2.fromAccount) !== null && _props$row2$fromAccou !== void 0 && (_props$row2$fromAccou2 = _props$row2$fromAccou.data) !== null && _props$row2$fromAccou2 !== void 0 && _props$row2$fromAccou2.email ? _c('div', [_c('span', [_vm._v(" Email: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : (_props$row3$fromAccou = _props$row3.fromAccount) === null || _props$row3$fromAccou === void 0 ? void 0 : (_props$row3$fromAccou2 = _props$row3$fromAccou.data) === null || _props$row3$fromAccou2 === void 0 ? void 0 : _props$row3$fromAccou2.email))])])]) : _vm._e(), props !== null && props !== void 0 && (_props$row4 = props.row) !== null && _props$row4 !== void 0 && (_props$row4$fromAccou = _props$row4.fromAccount) !== null && _props$row4$fromAccou !== void 0 && (_props$row4$fromAccou2 = _props$row4$fromAccou.data) !== null && _props$row4$fromAccou2 !== void 0 && _props$row4$fromAccou2.account_number ? _c('div', [_c('span', [_vm._v(" Acc No: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : (_props$row5$fromAccou = _props$row5.fromAccount) === null || _props$row5$fromAccou === void 0 ? void 0 : (_props$row5$fromAccou2 = _props$row5$fromAccou.data) === null || _props$row5$fromAccou2 === void 0 ? void 0 : _props$row5$fromAccou2.account_number))])])]) : _vm._e(), props !== null && props !== void 0 && (_props$row6 = props.row) !== null && _props$row6 !== void 0 && (_props$row6$fromAccou = _props$row6.fromAccount) !== null && _props$row6$fromAccou !== void 0 && (_props$row6$fromAccou2 = _props$row6$fromAccou.data) !== null && _props$row6$fromAccou2 !== void 0 && _props$row6$fromAccou2.account_holder_name ? _c('div', [_c('span', [_vm._v(" Holder Name: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : (_props$row7$fromAccou = _props$row7.fromAccount) === null || _props$row7$fromAccou === void 0 ? void 0 : (_props$row7$fromAccou2 = _props$row7$fromAccou.data) === null || _props$row7$fromAccou2 === void 0 ? void 0 : _props$row7$fromAccou2.account_holder_name))])])]) : _vm._e(), _c('div', [_c('span', [_vm._v(" Currency: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : (_props$row8$fromAccou = _props$row8.fromAccount) === null || _props$row8$fromAccou === void 0 ? void 0 : (_props$row8$fromAccou2 = _props$row8$fromAccou.data) === null || _props$row8$fromAccou2 === void 0 ? void 0 : _props$row8$fromAccou2.currency))])])])])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_to_account' ? [_c('span', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : (_props$row9$toAccount = _props$row9.toAccount) === null || _props$row9$toAccount === void 0 ? void 0 : (_props$row9$toAccount2 = _props$row9$toAccount.data) === null || _props$row9$toAccount2 === void 0 ? void 0 : _props$row9$toAccount2.name))]), _c('div', {
          staticClass: "cell-with-description"
        }, [props !== null && props !== void 0 && (_props$row10 = props.row) !== null && _props$row10 !== void 0 && (_props$row10$toAccoun = _props$row10.toAccount) !== null && _props$row10$toAccoun !== void 0 && (_props$row10$toAccoun2 = _props$row10$toAccoun.data) !== null && _props$row10$toAccoun2 !== void 0 && _props$row10$toAccoun2.email ? _c('div', [_c('span', [_vm._v(" Email: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : (_props$row11$toAccoun = _props$row11.toAccount) === null || _props$row11$toAccoun === void 0 ? void 0 : (_props$row11$toAccoun2 = _props$row11$toAccoun.data) === null || _props$row11$toAccoun2 === void 0 ? void 0 : _props$row11$toAccoun2.email))])])]) : _vm._e(), props !== null && props !== void 0 && (_props$row12 = props.row) !== null && _props$row12 !== void 0 && (_props$row12$toAccoun = _props$row12.toAccount) !== null && _props$row12$toAccoun !== void 0 && (_props$row12$toAccoun2 = _props$row12$toAccoun.data) !== null && _props$row12$toAccoun2 !== void 0 && _props$row12$toAccoun2.account_number ? _c('div', [_c('span', [_vm._v(" Acc No: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row13 = props.row) === null || _props$row13 === void 0 ? void 0 : (_props$row13$toAccoun = _props$row13.toAccount) === null || _props$row13$toAccoun === void 0 ? void 0 : (_props$row13$toAccoun2 = _props$row13$toAccoun.data) === null || _props$row13$toAccoun2 === void 0 ? void 0 : _props$row13$toAccoun2.account_number))])])]) : _vm._e(), props !== null && props !== void 0 && (_props$row14 = props.row) !== null && _props$row14 !== void 0 && (_props$row14$toAccoun = _props$row14.toAccount) !== null && _props$row14$toAccoun !== void 0 && (_props$row14$toAccoun2 = _props$row14$toAccoun.data) !== null && _props$row14$toAccoun2 !== void 0 && _props$row14$toAccoun2.account_holder_name ? _c('div', [_c('span', [_vm._v(" Holder Name: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : (_props$row15$toAccoun = _props$row15.toAccount) === null || _props$row15$toAccoun === void 0 ? void 0 : (_props$row15$toAccoun2 = _props$row15$toAccoun.data) === null || _props$row15$toAccoun2 === void 0 ? void 0 : _props$row15$toAccoun2.account_holder_name))])])]) : _vm._e(), _c('div', [_c('span', [_vm._v(" Currency: "), _c('b', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row16 = props.row) === null || _props$row16 === void 0 ? void 0 : (_props$row16$toAccoun = _props$row16.toAccount) === null || _props$row16$toAccoun === void 0 ? void 0 : (_props$row16$toAccoun2 = _props$row16$toAccoun.data) === null || _props$row16$toAccoun2 === void 0 ? void 0 : _props$row16$toAccoun2.currency))])])])])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) === 'format_remarks' ? [_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-sm cell-with-description",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click() {
              var _props$row17;
              return _vm.showDescriptionModal((_props$row17 = props.row) === null || _props$row17 === void 0 ? void 0 : _props$row17.remarks);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_amount' ? [_c('FormatCurrency', {
          attrs: {
            "amount": (_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : _props$row18.amount,
            "currency": props === null || props === void 0 ? void 0 : (_props$row19 = props.row) === null || _props$row19 === void 0 ? void 0 : _props$row19.currency
          }
        })] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column5 = props.column) === null || _props$column5 === void 0 ? void 0 : _props$column5.field) === 'format_currency' ? [_c('FormatCurrency', {
          attrs: {
            "type": 'currency',
            "amount": (_props$row20 = props.row) === null || _props$row20 === void 0 ? void 0 : _props$row20.amount,
            "currency": props === null || props === void 0 ? void 0 : (_props$row21 = props.row) === null || _props$row21 === void 0 ? void 0 : _props$row21.currency
          }
        })] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column6 = props.column) === null || _props$column6 === void 0 ? void 0 : _props$column6.field) === 'format_status' ? [props !== null && props !== void 0 && (_props$row22 = props.row) !== null && _props$row22 !== void 0 && _props$row22.status ? [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-success"
          }
        }, [_vm._v("Active")])] : !(props !== null && props !== void 0 && (_props$row23 = props.row) !== null && _props$row23 !== void 0 && _props$row23.status) ? [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-danger"
          }
        }, [_vm._v("Inactive")])] : _vm._e()] : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "description-modal",
      "centered": "",
      "title": "Remarks",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenDescriptionModal
    }
  }, [_c('b-card-text', [_vm._v(" " + _vm._s(_vm.modalDescription) + " ")])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-accounts-transfers-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Account Transfer Information ' : 'Account Transfer Information',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "accountTransferValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Form Account ",
      "label-for": "from-account"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "from account ",
      "vid": "from_account_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          staticClass: "custom-font",
          attrs: {
            "id": "from-account",
            "placeholder": "Choose an Account ",
            "options": _vm.fromAccountIdOption,
            "reduce": function reduce(country) {
              return country.id;
            },
            "selectable": function selectable(option) {
              return option.disable;
            },
            "label": "name"
          },
          on: {
            "input": _vm.showFilterToAccount
          },
          model: {
            value: _vm.fromAccountId,
            callback: function callback($$v) {
              _vm.fromAccountId = $$v;
            },
            expression: "fromAccountId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "To Account ",
      "label-for": "to-account"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "to account",
      "vid": "to_account_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('v-select', {
          staticClass: "custom-font",
          attrs: {
            "id": "to-account",
            "placeholder": "Choose an Account",
            "options": _vm.toAccountIdOption,
            "reduce": function reduce(country) {
              return country.id;
            },
            "label": "name"
          },
          on: {
            "input": _vm.showFilterFromAccount
          },
          model: {
            value: _vm.toAccountId,
            callback: function callback($$v) {
              _vm.toAccountId = $$v;
            },
            expression: "toAccountId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Amount ",
      "label-for": "amount "
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "amount ",
      "vid": "amount ",
      "rules": "required|numeric|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          staticClass: "custom-font",
          attrs: {
            "id": "amount",
            "type": "number",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Balance Amount"
          },
          model: {
            value: _vm.amount,
            callback: function callback($$v) {
              _vm.amount = $$v;
            },
            expression: "amount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Remarks ",
      "label-for": "Remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-textarea', {
          staticClass: "custom-font",
          attrs: {
            "id": "remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Add a Remarks"
          },
          model: {
            value: _vm.remarks,
            callback: function callback($$v) {
              _vm.remarks = $$v;
            },
            expression: "remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.loading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }